import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

export type BillingInterval = 'monthly' | 'yearly'

export interface PaginationState {
  page: number
  pageSize: number
}

export interface BillingUiState {
  billingInterval: BillingInterval
  invoicePagination: PaginationState
  usagePagination: PaginationState
}

const initialState: BillingUiState = {
  billingInterval: 'monthly',
  invoicePagination: { page: 1, pageSize: 25 },
  usagePagination: { page: 1, pageSize: 25 },
}

export const billingUiSlice = createSlice({
  name: 'billingUi',
  initialState,
  reducers: {
    setBillingInterval: (state, action: PayloadAction<BillingInterval>) => {
      state.billingInterval = action.payload
    },
    setInvoicePage: (state, action: PayloadAction<number>) => {
      state.invoicePagination.page = action.payload
    },
    setInvoicePageSize: (state, action: PayloadAction<number>) => {
      state.invoicePagination.pageSize = action.payload
      state.invoicePagination.page = 1
    },
    setUsagePage: (state, action: PayloadAction<number>) => {
      state.usagePagination.page = action.payload
    },
    setUsagePageSize: (state, action: PayloadAction<number>) => {
      state.usagePagination.pageSize = action.payload
      state.usagePagination.page = 1
    },
    resetBillingUi: () => initialState,
  },
})

export const {
  setBillingInterval,
  setInvoicePage,
  setInvoicePageSize,
  setUsagePage,
  setUsagePageSize,
  resetBillingUi,
} = billingUiSlice.actions

export const billingUiReducer = billingUiSlice.reducer

export const selectBillingInterval = (state: { billingUi: BillingUiState }) =>
  state.billingUi.billingInterval

export const selectInvoicePagination = (state: { billingUi: BillingUiState }) =>
  state.billingUi.invoicePagination

export const selectUsagePagination = (state: { billingUi: BillingUiState }) =>
  state.billingUi.usagePagination
